export type TextEffectInput = {
  attribute: string;
  document: Document;
  value: string;
  variable: string;
};

export type ResetTextEffectInput = Omit<TextEffectInput, "value">;

const styleSelector = 'style[data-migrosone-a11y-page-effects="text"]';
const widgetRootSelector = "#migrosone-a11y-widget-root";
const textScaleSelector = `
body :where(.price-container, [class~="price"]):not(.price-container *):not(${widgetRootSelector}):not(${widgetRootSelector} *),
body :where(a, button, label, input, select, textarea, p, li, dt, dd, h1, h2, h3, h4, h5, h6, th, td, caption, figcaption, blockquote, summary, small, strong, em, b, i, span):not(:has(*)):not(.price-container *):not([class~="price"] *):not(${widgetRootSelector}):not(${widgetRootSelector} *),
body div:not(:has(*)):not(.price-container *):not([class~="price"] *):not(${widgetRootSelector}):not(${widgetRootSelector} *)
`;

const textEffectStyles = `
html[data-migrosone-a11y-text-effects] body {
  font-family: var(--migrosone-a11y-font-family, inherit);
  line-height: var(--migrosone-a11y-line-height, inherit);
  letter-spacing: var(--migrosone-a11y-letter-spacing, normal);
}

html[data-migrosone-a11y-text-effects][data-migrosone-a11y-text-size] ${textScaleSelector} {
  zoom: var(--migrosone-a11y-text-scale, 100%);
}
`;

function canUseDocument(document: Document) {
  return Boolean(document.head && document.documentElement);
}

function ensureTextEffectStyle(document: Document) {
  const existing = document.querySelector(styleSelector);
  if (existing) {
    return true;
  }

  const style = document.createElement("style");
  style.setAttribute("data-migrosone-a11y-page-effects", "text");
  style.textContent = textEffectStyles;
  document.head.appendChild(style);
  return true;
}

export function applyTextEffectValue({
  attribute,
  document,
  value,
  variable,
}: TextEffectInput) {
  if (!canUseDocument(document)) {
    return false;
  }

  ensureTextEffectStyle(document);
  document.documentElement.style.setProperty(variable, value);
  document.documentElement.setAttribute(attribute, "true");
  document.documentElement.setAttribute("data-migrosone-a11y-text-effects", "true");
  return true;
}

export function resetTextEffectValue({
  attribute,
  document,
  variable,
}: ResetTextEffectInput) {
  if (!canUseDocument(document)) {
    return false;
  }

  document.documentElement.style.removeProperty(variable);
  document.documentElement.removeAttribute(attribute);
  return true;
}
